export const VERIFY_AI_CONTENT_ENDPOINT = 'aicontent/test';
export const VERIFY_AI_CONTENT_UPLOAD_FIELD = 'file';
export const VERIFY_AI_CONTENT_TIMEOUT_MS = 300000;

export enum AiContentVerificationErrorCode {
  UPLOAD_MISSING = 'upload_missing',
  UPLOAD_TOO_LARGE = 'upload_too_large',
  UNSUPPORTED_FILE = 'unsupported_file',
  UPLOAD_REJECTED = 'upload_rejected',
  RATE_LIMITED = 'rate_limited',
  TOO_MANY_CONCURRENT_REQUESTS = 'too_many_concurrent_requests',
}

export interface AiContentVerificationResult {
  isAiGenerated: boolean;
  fileName: string;
  mediaKind: string;
  digitalSourceType: string | null;
  provider: string | null;
  system: string | null;
  provenanceId: string | null;
  createdAt: string | null;
}

export interface AiContentVerificationFailure {
  code: AiContentVerificationErrorCode | null;
  message: string;
}

export interface AiContentVerificationState {
  file: File | null;
  isVerifying: boolean;
  result: AiContentVerificationResult | null;
  failure: AiContentVerificationFailure | null;
}

export const INITIAL_AI_CONTENT_VERIFICATION_STATE: AiContentVerificationState = {
  file: null,
  isVerifying: false,
  result: null,
  failure: null,
};

export interface AiContentVerification {
  verificationState: AiContentVerificationState;
  selectFile: (file: File | null) => void;
  verifyFile: (file: File) => Promise<void>;
  rejectFile: (file: File, failure: AiContentVerificationFailure) => void;
  resetVerification: () => void;
}
